<template>
  <div class="cjIndex" direction="vertical">
    <el-container>
      <el-header>
        <el-row :style="{marginTop:'1vh'}">大人来也抽签摇号系统</el-row>        
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>
<style>
.cjIndex{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /*设置内部填充为0，几个布局元素之间没有间距*/
  padding: 0px;
  /*外部间距也是如此设置*/
  margin: 0px;
  /*统一设置高度为100%*/
  height: 100%;
}

.el-header{
  background-color: #409EFF;
  color: white;
  height: 6vh !important;
  font-size: 3vh;
  text-align: left !important;
}
</style>
<script>
export default {
  mounted:function(){
    //router.push("");
  },
  methods:{
    
  }
}
</script>